import { createFileRoute } from '@tanstack/react-router'

import { BillingRulesPage } from '#/modules/subscriptions/billing-rules-page'

export const Route = createFileRoute('/_shell/billing-rules')({
  component: BillingRulesPage,
})
